import { Task } from '@/api';
import { MapUserLocation } from '../../components/user-map-marker';
import { createContext } from 'react';

export interface TaskDashboardContextData {
    tasks: Task[];
    locations: MapUserLocation[];
    loading: boolean;
}

export const TaskDashboardContext = createContext<
    TaskDashboardContextData | undefined
>(undefined);
